import { colors } from 'ui/theme/colors';
import { getColor } from '../../utils';
import { SvgIcon, SvgIconProps } from '../../SvgIcon';

export const ChevronLeft24 = ({
  height = 24,
  width = 24,
  color = colors.iconPrimary,
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon data-temporary-fix height={height} width={width} viewBox="0 0 24 24" {...props}>
    <path
      d="M8 12.0477C8 12.3985 8.15123 12.6992 8.40329 12.8996L13.9485 17.7606C14.3014 18.1114 14.9063 18.0613 15.2592 17.7105C15.6121 17.3597 15.5617 16.7584 15.2088 16.4076C15.2088 16.4076 15.2088 16.4076 15.1584 16.3575L10.3189 12.0978C10.2685 12.0477 10.2685 11.9976 10.3189 11.8974L15.1584 7.63776C15.5617 7.28696 15.6121 6.73572 15.2592 6.33481C14.9063 5.93391 14.3518 5.88379 13.9485 6.23459C13.9485 6.23459 13.9485 6.23459 13.8981 6.2847L8.35288 11.1457C8.15123 11.3962 8 11.6969 8 12.0477Z"
      fill={getColor(color, isColorInherited)}
    />
  </SvgIcon>
);
